/**
 * Icon resolver for scene compositions: stdlib icon id → inner-SVG body
 * (the scene GlyphNode contract — markup against a 24x24 viewBox, no outer
 * <svg> wrapper). Shared by the live `arch-scene-module` widget and the
 * headless SVG export so both render the same glyph.
 */
import { iconSvg } from "../generated/stdlib-widgets/arch.ui/icons.js";

export function resolveSceneIcon(id: string): string | undefined {
  return (
    iconSvg(id, 24)
      .replace(/^<svg[^>]*>/, "")
      .replace(/<\/svg>$/, "") || undefined
  );
}
